// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__3L--f","title":"InfoRow_title__1PJu2"};